import { StateAbbreviation, StateFullName } from "./types";

/**
 * Encapsulates the set of possible license plate states with their display names
 * and abbreviations.
 */
export class LicensePlateState {
  public static readonly Alabama = new LicensePlateState({
    fullName: "Alabama",
    abbreviation: "AL",
    countryCode: "US",
  });
  public static readonly Alaska = new LicensePlateState({ fullName: "Alaska", abbreviation: "AK", countryCode: "US" });
  public static readonly Arizona = new LicensePlateState({
    fullName: "Arizona",
    abbreviation: "AZ",
    countryCode: "US",
  });
  public static readonly Arkansas = new LicensePlateState({
    fullName: "Arkansas",
    abbreviation: "AR",
    countryCode: "US",
  });
  public static readonly California = new LicensePlateState({
    fullName: "California",
    abbreviation: "CA",
    countryCode: "US",
  });
  public static readonly Colorado = new LicensePlateState({
    fullName: "Colorado",
    abbreviation: "CO",
    countryCode: "US",
  });
  public static readonly Connecticut = new LicensePlateState({
    fullName: "Connecticut",
    abbreviation: "CT",
    countryCode: "US",
  });
  public static readonly Delaware = new LicensePlateState({
    fullName: "Delaware",
    abbreviation: "DE",
    countryCode: "US",
  });
  public static readonly DistrictOfColumbia = new LicensePlateState({
    fullName: "District of Columbia",
    abbreviation: "DC",
    countryCode: "US",
  });
  public static readonly Florida = new LicensePlateState({
    fullName: "Florida",
    abbreviation: "FL",
    countryCode: "US",
  });
  public static readonly Georgia = new LicensePlateState({
    fullName: "Georgia",
    abbreviation: "GA",
    countryCode: "US",
  });
  public static readonly Hawaii = new LicensePlateState({ fullName: "Hawaii", abbreviation: "HI", countryCode: "US" });
  public static readonly Idaho = new LicensePlateState({ fullName: "Idaho", abbreviation: "ID", countryCode: "US" });
  public static readonly Illinois = new LicensePlateState({
    fullName: "Illinois",
    abbreviation: "IL",
    countryCode: "US",
  });
  public static readonly Indiana = new LicensePlateState({
    fullName: "Indiana",
    abbreviation: "IN",
    countryCode: "US",
  });
  public static readonly Iowa = new LicensePlateState({ fullName: "Iowa", abbreviation: "IA", countryCode: "US" });
  public static readonly Kansas = new LicensePlateState({ fullName: "Kansas", abbreviation: "KS", countryCode: "US" });
  public static readonly Kentucky = new LicensePlateState({
    fullName: "Kentucky",
    abbreviation: "KY",
    countryCode: "US",
  });
  public static readonly Louisiana = new LicensePlateState({
    fullName: "Louisiana",
    abbreviation: "LA",
    countryCode: "US",
  });
  public static readonly Maine = new LicensePlateState({ fullName: "Maine", abbreviation: "ME", countryCode: "US" });
  public static readonly Maryland = new LicensePlateState({
    fullName: "Maryland",
    abbreviation: "MD",
    countryCode: "US",
  });
  public static readonly Massachusetts = new LicensePlateState({
    fullName: "Massachusetts",
    abbreviation: "MA",
    countryCode: "US",
  });
  public static readonly Michigan = new LicensePlateState({
    fullName: "Michigan",
    abbreviation: "MI",
    countryCode: "US",
  });
  public static readonly Minnesota = new LicensePlateState({
    fullName: "Minnesota",
    abbreviation: "MN",
    countryCode: "US",
  });
  public static readonly Mississippi = new LicensePlateState({
    fullName: "Mississippi",
    abbreviation: "MS",
    countryCode: "US",
  });
  public static readonly Missouri = new LicensePlateState({
    fullName: "Missouri",
    abbreviation: "MO",
    countryCode: "US",
  });
  public static readonly Montana = new LicensePlateState({
    fullName: "Montana",
    abbreviation: "MT",
    countryCode: "US",
  });
  public static readonly Nebraska = new LicensePlateState({
    fullName: "Nebraska",
    abbreviation: "NE",
    countryCode: "US",
  });
  public static readonly Nevada = new LicensePlateState({ fullName: "Nevada", abbreviation: "NV", countryCode: "US" });
  public static readonly NewHampshire = new LicensePlateState({
    fullName: "New Hampshire",
    abbreviation: "NH",
    countryCode: "US",
  });
  public static readonly NewJersey = new LicensePlateState({
    fullName: "New Jersey",
    abbreviation: "NJ",
    countryCode: "US",
  });
  public static readonly NewMexico = new LicensePlateState({
    fullName: "New Mexico",
    abbreviation: "NM",
    countryCode: "US",
  });
  public static readonly NewYork = new LicensePlateState({
    fullName: "New York",
    abbreviation: "NY",
    countryCode: "US",
  });
  public static readonly NorthCarolina = new LicensePlateState({
    fullName: "North Carolina",
    abbreviation: "NC",
    countryCode: "US",
  });
  public static readonly NorthDakota = new LicensePlateState({
    fullName: "North Dakota",
    abbreviation: "ND",
    countryCode: "US",
  });
  public static readonly Ohio = new LicensePlateState({ fullName: "Ohio", abbreviation: "OH", countryCode: "US" });
  public static readonly Oklahoma = new LicensePlateState({
    fullName: "Oklahoma",
    abbreviation: "OK",
    countryCode: "US",
  });
  public static readonly Oregon = new LicensePlateState({ fullName: "Oregon", abbreviation: "OR", countryCode: "US" });
  public static readonly Pennsylvania = new LicensePlateState({
    fullName: "Pennsylvania",
    abbreviation: "PA",
    countryCode: "US",
  });
  public static readonly RhodeIsland = new LicensePlateState({
    fullName: "Rhode Island",
    abbreviation: "RI",
    countryCode: "US",
  });
  public static readonly SouthCarolina = new LicensePlateState({
    fullName: "South Carolina",
    abbreviation: "SC",
    countryCode: "US",
  });
  public static readonly SouthDakota = new LicensePlateState({
    fullName: "South Dakota",
    abbreviation: "SD",
    countryCode: "US",
  });
  public static readonly Tennessee = new LicensePlateState({
    fullName: "Tennessee",
    abbreviation: "TN",
    countryCode: "US",
  });
  public static readonly Texas = new LicensePlateState({ fullName: "Texas", abbreviation: "TX", countryCode: "US" });
  public static readonly Utah = new LicensePlateState({ fullName: "Utah", abbreviation: "UT", countryCode: "US" });
  public static readonly Vermont = new LicensePlateState({
    fullName: "Vermont",
    abbreviation: "VT",
    countryCode: "US",
  });
  public static readonly Virginia = new LicensePlateState({
    fullName: "Virginia",
    abbreviation: "VA",
    countryCode: "US",
  });
  public static readonly Washington = new LicensePlateState({
    fullName: "Washington",
    abbreviation: "WA",
    countryCode: "US",
  });
  public static readonly WestVirginia = new LicensePlateState({
    fullName: "West Virginia",
    abbreviation: "WV",
    countryCode: "US",
  });
  public static readonly Wisconsin = new LicensePlateState({
    fullName: "Wisconsin",
    abbreviation: "WI",
    countryCode: "US",
  });
  public static readonly Wyoming = new LicensePlateState({
    fullName: "Wyoming",
    abbreviation: "WY",
    countryCode: "US",
  });
  public static readonly Alberta = new LicensePlateState({
    fullName: "Alberta",
    abbreviation: "AB",
    countryCode: "CA",
  });
  public static readonly BritishColumbia = new LicensePlateState({
    fullName: "British Columbia",
    abbreviation: "BC",
    countryCode: "CA",
  });
  public static readonly Manitoba = new LicensePlateState({
    fullName: "Manitoba",
    abbreviation: "MB",
    countryCode: "CA",
  });
  public static readonly NewBrunswick = new LicensePlateState({
    fullName: "New Brunswick",
    abbreviation: "NB",
    countryCode: "CA",
  });
  public static readonly NewfoundlandAndLabrador = new LicensePlateState({
    fullName: "Newfoundland and Labrador",
    abbreviation: "NL",
    countryCode: "CA",
  });
  public static readonly NorthwestTerritories = new LicensePlateState({
    fullName: "Northwest Territories",
    abbreviation: "NT",
    countryCode: "CA",
  });
  public static readonly NovaScotia = new LicensePlateState({
    fullName: "Nova Scotia",
    abbreviation: "NS",
    countryCode: "CA",
  });
  public static readonly Ontario = new LicensePlateState({
    fullName: "Ontario",
    abbreviation: "ON",
    countryCode: "CA",
  });
  public static readonly PrinceEdwardIsland = new LicensePlateState({
    fullName: "Prince Edward Island",
    abbreviation: "PE",
    countryCode: "CA",
  });
  public static readonly PuertoRico = new LicensePlateState({
    fullName: "Puerto Rico",
    abbreviation: "PR",
    countryCode: "US",
  });
  public static readonly Quebec = new LicensePlateState({
    fullName: "Quebec",
    abbreviation: "QC",
    countryCode: "CA",
  });
  public static readonly Saskatchewan = new LicensePlateState({
    fullName: "Saskatchewan",
    abbreviation: "SK",
    countryCode: "CA",
  });
  public static readonly YukonTerritory = new LicensePlateState({
    fullName: "Yukon",
    abbreviation: "YT",
    countryCode: "CA",
  });
  public static readonly All = [
    LicensePlateState.Alabama,
    LicensePlateState.Alaska,
    LicensePlateState.Arizona,
    LicensePlateState.Arkansas,
    LicensePlateState.California,
    LicensePlateState.Colorado,
    LicensePlateState.Connecticut,
    LicensePlateState.Delaware,
    LicensePlateState.DistrictOfColumbia,
    LicensePlateState.Florida,
    LicensePlateState.Georgia,
    LicensePlateState.Hawaii,
    LicensePlateState.Idaho,
    LicensePlateState.Illinois,
    LicensePlateState.Indiana,
    LicensePlateState.Iowa,
    LicensePlateState.Kansas,
    LicensePlateState.Kentucky,
    LicensePlateState.Louisiana,
    LicensePlateState.Maine,
    LicensePlateState.Maryland,
    LicensePlateState.Massachusetts,
    LicensePlateState.Michigan,
    LicensePlateState.Minnesota,
    LicensePlateState.Mississippi,
    LicensePlateState.Missouri,
    LicensePlateState.Montana,
    LicensePlateState.Nebraska,
    LicensePlateState.Nevada,
    LicensePlateState.NewHampshire,
    LicensePlateState.NewJersey,
    LicensePlateState.NewMexico,
    LicensePlateState.NewYork,
    LicensePlateState.NorthCarolina,
    LicensePlateState.NorthDakota,
    LicensePlateState.Ohio,
    LicensePlateState.Oklahoma,
    LicensePlateState.Oregon,
    LicensePlateState.Pennsylvania,
    LicensePlateState.RhodeIsland,
    LicensePlateState.SouthCarolina,
    LicensePlateState.SouthDakota,
    LicensePlateState.Tennessee,
    LicensePlateState.Texas,
    LicensePlateState.Utah,
    LicensePlateState.Vermont,
    LicensePlateState.Virginia,
    LicensePlateState.Washington,
    LicensePlateState.WestVirginia,
    LicensePlateState.Wisconsin,
    LicensePlateState.Wyoming,
    LicensePlateState.Alberta,
    LicensePlateState.BritishColumbia,
    LicensePlateState.Manitoba,
    LicensePlateState.NewBrunswick,
    LicensePlateState.NewfoundlandAndLabrador,
    LicensePlateState.NorthwestTerritories,
    LicensePlateState.NovaScotia,
    LicensePlateState.Ontario,
    LicensePlateState.PrinceEdwardIsland,
    LicensePlateState.PuertoRico,
    LicensePlateState.Quebec,
    LicensePlateState.Saskatchewan,
    LicensePlateState.YukonTerritory,
  ];

  public static readonly ByAbbreviation: Record<StateAbbreviation, LicensePlateState> = Object.freeze(
    LicensePlateState.All.reduce((acc, cur) => {
      return {
        ...acc,
        [cur.abbreviation]: cur,
      };
    }, {} as Record<StateAbbreviation, LicensePlateState>),
  );

  public static FromAbbreviation(abbrev: StateAbbreviation): LicensePlateState {
    return this.ByAbbreviation[abbrev];
  }

  /** Full name of the state */
  public readonly fullName: StateFullName;
  /** Abbreviation/code of the state */
  public readonly abbreviation: StateAbbreviation;
  /** Country code of the state */
  public readonly countryCode: string;

  constructor({ fullName, abbreviation, countryCode }: LicensePlateStateProps) {
    this.fullName = fullName;
    this.abbreviation = abbreviation;
    this.countryCode = countryCode;
  }
}

interface LicensePlateStateProps {
  fullName: StateFullName;
  abbreviation: StateAbbreviation;
  countryCode: string;
}

export default LicensePlateState;
